<template>
  <div class="image-text-block">
    <svg class="icon icon-pic" aria-hidden="true">
      <use xlink:href="#icontuwenxiaoxihuifu"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'imageText'
}
</script>

<style lang="scss" scoped>
.image-text-block {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 215px;

  .icon-pic {
    font-size: 118px;
    color: #e5e5e5;
  }
}
</style>
